// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../microservices/dash/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playposit-text-box{display:flex}.playposit-text-box .icon-rod-wrapper{width:24px;min-width:24px;display:flex;flex-direction:column;align-items:center}.playposit-text-box .icon-rod-wrapper .color-rod{flex:1;width:6px}.playposit-text-box .pl-2{width:80%}.playposit-text-box .text-box-content{color:rgba(0,0,0,.54)}", ""]);
// Exports
module.exports = exports;
